import React, { useEffect } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { ValidatorForm } from "react-material-ui-form-validator";
import { InputField } from "../../../../../components/common";

const useStyles = makeStyles(theme => ({
  dialogPaper: {
    borderRadius: 16,
    maxWidth: 520,
    width: "100%",
  },
  dialogTitle: {
    padding: theme.spacing(3),
    backgroundColor: "#fff !important",
    borderBottom: `1px solid ${theme.palette.action.hover}`,
  },
  dialogTitleText: {
    fontWeight: 600,
    fontSize: 18,
    color: theme.palette.text.primary,
  },
  dialogContent: {
    padding: theme.spacing(3),
    backgroundColor: "#fff",
  },
  fieldRow: {
    marginBottom: theme.spacing(2),
  },
  dialogActions: {
    padding: theme.spacing(2, 3, 3),
    borderTop: `1px solid ${theme.palette.action.hover}`,
    backgroundColor: "#fff",
    display: "flex",
    alignItems: "center",
  },
  fullDetailsButton: {
    padding: 0,
    fontWeight: 600,
    textTransform: "none",
    letterSpacing: 0.5,
  },
  actionButtons: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    textTransform: "none",
  },
  cancelButton: {
    textTransform: "none !important",
  },
}));

const AddProspectModal = ({
  open,
  onClose,
  onAddFullDetails,
  onAdd,
  values = {},
  onFieldChange = () => {},
}) => {
  const classes = useStyles();

  const handleSubmit = () => {
    if (onAdd) onAdd();
    else if (onClose) onClose();
  };

  useEffect(() => {
    const todayISO = () => new Date().toISOString().split("T")[0];
    ValidatorForm.addValidationRule("isNotFutureDate", value => {
      if (!value) return true;
      return value <= todayISO();
    });
    return () => {
      ValidatorForm.removeValidationRule?.("isNotFutureDate");
    };
  }, []);

  const today = new Date().toISOString().split("T")[0];

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth='sm'
      fullWidth
      classes={{ paper: classes.dialogPaper }}>
      <DialogTitle disableTypography className={classes.dialogTitle}>
        <Typography className={classes.dialogTitleText}>
          Add prospect
        </Typography>
      </DialogTitle>

      <DialogContent className={classes.dialogContent}>
        <ValidatorForm
          id='add-prospect-form'
          onSubmit={handleSubmit}
          instantValidate>
          <Grid container spacing={2} className={classes.fieldRow}>
            <Grid item xs={12} sm={6}>
              <InputField
                placeholder='First name'
                inputlabel='First name'
                id='ap-firstname'
                name='ap-firstname'
                value={values.firstName ?? ""}
                onChange={e => onFieldChange("firstName", e.target.value)}
                showRequired
                validators={[
                  "required",
                  "matchRegexp:^[A-Za-z']+(?: [A-Za-z']+)*$",
                  "matchRegexp:^.{0,50}$",
                ]}
                errorMessages={[
                  "This field is required",
                  "Only letters, apostrophes and spaces between words are allowed",
                  "Maximum length is 50 characters",
                ]}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <InputField
                placeholder='Last name'
                inputlabel='Last name'
                id='ap-lastname'
                name='ap-lastname'
                value={values.lastName ?? ""}
                onChange={e => onFieldChange("lastName", e.target.value)}
                showRequired
                validators={[
                  "required",
                  "matchRegexp:^[A-Za-z']+(?: [A-Za-z']+)*$",
                  "matchRegexp:^.{0,50}$",
                ]}
                errorMessages={[
                  "This field is required",
                  "Only letters, apostrophes and spaces between words are allowed",
                  "Maximum length is 50 characters",
                ]}
              />
            </Grid>

            <Grid item xs={12}>
              <InputField
                placeholder='Email'
                inputlabel='Email'
                id='ap-email'
                name='ap-email'
                value={values.email ?? ""}
                onChange={e => onFieldChange("email", e.target.value)}
                showRequired
                validators={["required", "isEmail", "matchRegexp:^.{0,100}$"]}
                errorMessages={[
                  "This field is required",
                  "Email is not valid",
                  "Maximum length is 100 characters",
                ]}
              />
            </Grid>

            <Grid item xs={12}>
              <InputField
                placeholder='Nick Name'
                inputlabel='Nick Name'
                id='ap-nickname'
                name='ap-nickname'
                value={values.nickname ?? ""}
                onChange={e => onFieldChange("nickname", e.target.value)}
                validators={["matchRegexp:^.{0,50}$"]}
                errorMessages={["Maximum length is 50 characters"]}
              />
            </Grid>

            {/* <Grid item xs={12}>
              <InputField
                placeholder="Birth date"
                inputlabel="Birth date"
                type="date"
                id="ap-birthdate"
                name="ap-birthdate"
                value={values.birthDate ?? ""}
                onChange={e => onFieldChange("birthDate", e.target.value)}
                validators={["isNotFutureDate"]}
                errorMessages={["Birth date cannot be in the future"]}
                inputProps={{ max: today }}
              />
            </Grid> */}
          </Grid>

          <button type='submit' style={{ display: "none" }} />
        </ValidatorForm>
      </DialogContent>

      <DialogActions className={classes.dialogActions}>
        <Button
          onClick={onAddFullDetails}
          color='primary'
          className={classes.fullDetailsButton}>
          Add Full Details
        </Button>
        <div className={classes.actionButtons}>
          <Button
            onClick={onClose}
            className={classes.cancelButton}
            color='default'>
            Cancel
          </Button>
          <Button
            variant='contained'
            color='primary'
            type='submit'
            form='add-prospect-form'>
            Add
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default AddProspectModal;
